document.addEventListener("DOMContentLoaded", (event) => {
  const thumbsEl = document.querySelector(
    ".thumb-slider:not(.--main-product-section .thumb-slider)",
  );
  const mainEl = document.querySelector(
    ".gallery-slider:not(.--main-product-section .gallery-slider)",
  );

  if (thumbsEl && mainEl) {
    // First initialize the thumbs slider
    const galleryThumbs = new Swiper(thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 15,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: thumbsEl.querySelector(".swiper-button-next"),
        prevEl: thumbsEl.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        200: { slidesPerView: 4 },
        600: { slidesPerView: 3 },
      },
    });
    // Then initialize the main slider with the thumbs reference
    new Swiper(mainEl, {
      slidesPerView: 1,
      thumbs: { swiper: galleryThumbs },
      breakpoints: {
        200: { slidesPerView: 1 },
        600: { effect: "fade", slidesPerView: 1 },
      },
    });
  }

  const scrollButtons = document.querySelectorAll(".scroll-btn-new");

  scrollButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = button.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offset = 50;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});

const accordionWrappers = document.querySelectorAll(".accordion__wrapper");
accordionWrappers.forEach((wrapper, index) => {
  const title = wrapper.querySelector(".accr__title");
  const content = wrapper.querySelector(".accr__content");

  if (index === 0) {
    wrapper.classList.add("accordion-open");
    content.style.maxHeight = content.scrollHeight + "px";
  } else {
    wrapper.classList.add("accordion-closed");
  }

  title.addEventListener("click", () => {
    const isOpen = wrapper.classList.contains("accordion-open");

    accordionWrappers.forEach((otherWrapper) => {
      if (otherWrapper !== wrapper) {
        otherWrapper.classList.remove("accordion-open");
        otherWrapper.classList.add("accordion-closed");
        otherWrapper.querySelector(".accr__content").style.maxHeight = "0";
      }
    });

    if (isOpen) {
      wrapper.classList.remove("accordion-open");
      wrapper.classList.add("accordion-closed");
      content.style.maxHeight = "0";
    } else {
      wrapper.classList.remove("accordion-closed");
      wrapper.classList.add("accordion-open");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});
